import React from 'react';
import { useTheme } from '../../contexts/ThemeContext.tsx';

interface TagProps {
  className?: string;
}

export const NewTag: React.FC<TagProps> = ({ className = '' }) => (
  <span className={`ml-2 px-1.5 py-0.5 text-xs font-semibold text-green-700 bg-green-100 rounded ${className}`}>
    NOVO
  </span>
);

export const BetaTag: React.FC<TagProps> = ({ className = '' }) => {
  const { isDark } = useTheme();

  return (
    <span className={`ml-1.5 inline-flex items-center rounded-sm px-1 py-px text-[9px] font-medium leading-none tracking-[0.04em] ${
      isDark ? 'bg-gray-700/70 text-gray-300' : 'bg-gray-100 text-gray-500'
    } ${className}`}>
      BETA
    </span>
  );
};

export const ProTag: React.FC<TagProps> = ({ className = '' }) => (
  <span className={`ml-2 px-1.5 py-0.5 text-xs font-semibold text-purple-700 bg-purple-100 rounded ${className}`}>
    PRO
  </span>
);

export const ComingSoonTag: React.FC<TagProps> = ({ className = '' }) => (
  <span className={`ml-2 px-1.5 py-0.5 text-xs font-semibold text-gray-500 bg-gray-100 rounded ${className}`}>
    EM BREVE
  </span>
);

export const ExperimentalTag: React.FC<TagProps> = ({ className = '' }) => (
  <span className={`ml-2 px-1.5 py-0.5 text-xs font-semibold text-orange-700 bg-orange-100 rounded ${className}`}>
    EXPERIMENTAL
  </span>
);

export const AlphaTag: React.FC<TagProps> = ({ className = '' }) => (
  <span className={`ml-2 px-1.5 py-0.5 text-xs font-semibold text-red-700 bg-red-100 rounded ${className}`}>
    ALPHA
  </span>
);

// Export all tags as a namespace for convenience
const StatusTags = {
  New: NewTag,
  Beta: BetaTag,
  Pro: ProTag,
  ComingSoon: ComingSoonTag,
  Experimental: ExperimentalTag,
  Alpha: AlphaTag
};

export default StatusTags;
